export function initDataHref() {

    const historyLength = window.history.length;
    const hasHistory = historyLength > 1;

    var closing = sessionStorage.getItem("closing");
    if(closing) {
        const currentUrl = removeQueryAndHash(window.location.href);
        if(closing == currentUrl && hasHistory) {
            window.history.back();
        }
    }

    sessionStorage.removeItem("closing");

    if(hasHistory) {
        document.querySelectorAll('a[data-href="close"]').forEach(x => {
            x.addEventListener("click", e => {
                const currentUrl = removeQueryAndHash(window.location.href);
                sessionStorage.setItem("closing", currentUrl);
                e.preventDefault();
                window.history.back();
            });
        });
    }

    function removeQueryAndHash(url) {
        return url.split("?")[0].split("#")[0];
    }
}